import * as React from 'react';

import { Outside } from '@cian/ui-kit/prev/outside';
import { Respective } from '../Respective';
import { VideoOverlay } from '../VideoOverlay';
import { trackPlayClick } from '../utils/tracking';

import * as styles from './styles.css';

interface IVideoProps {
  videoUrl: string;
}

export const Video: React.FC<IVideoProps> = ({ videoUrl }) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const setOpen = React.useMemo(
    () => () => {
      setIsOpen(true);
      trackPlayClick();
    },
    [],
  );
  const setClose = React.useMemo(() => () => setIsOpen(false), []);

  return (
    <div className={styles['container']}>
      <Outside onOutside={setClose}>
        <Respective>
          <VideoOverlay hidden={isOpen} openVideo={setOpen} />
          <div className={styles['iframe-container']}>
            {isOpen && (
              <iframe
                className={styles['iframe']}
                src={`${videoUrl}?autoplay=1`}
                frameBorder="0"
                allow="autoplay"
                allowFullScreen
              />
            )}
          </div>
        </Respective>
      </Outside>
    </div>
  );
};

Video.displayName = 'Video';
